import type { ScLinkField } from '@core/jss-models';
import { createAction, props } from '@ngrx/store';
import type { GeneralAdviceForm } from '@feh/standalone-forms-models';

const prefix = '[General Advice Form]';

export const submitGeneralAdviceForm = createAction(
  `${prefix} Submit form`,
  props<{
    payload: {
      formData: GeneralAdviceForm['value'];
      scContext: {
        productType: string;
        channel: string;
        subChannel?: string;
        campaignName?: string;
      };
      e2eTrackingId: string;
    };
  }>()
);

export const setRedirectUrl = createAction(
  `${prefix} Set redirect url`,
  props<{
    redirectUrl: ScLinkField;
  }>()
);

export const resetSubmitState = createAction(`${prefix} Reset submit state`);
